import React from "react";
// COMPONENTS
import SiteButton from "Components/WebsiteTheme/SiteButton";
import { ToneIcon } from "Components/WebsiteTheme/SiteIcons";
import { revealProps } from "Components/WebsiteTheme/Reveal";
import { CTA, PILLARS } from "Components/WebsiteTheme/site.data";
// STYLES
import { HomeHero } from "./LandingPage.style";
// IMAGES
import HeroPhoto from "Assets/Images/ClassroomPilot/hero-pilot-classroom.jpg";

/** Home hero: title, intro, Classroom Pilot button, the three pillars, classroom photo. */
const HeroBanner = () => (
	<HomeHero className="sm_hero">
		<div className="sm_container sm_hero_inner">
			<div className="sm_hero_photo">
				<img src={HeroPhoto} alt="A teacher holding a tablet while students work on laptops in a classroom" width="1000" height="558" fetchpriority="high" />
				<p className="sm_hero_tagline sm_hand" aria-hidden="true">
					Built for Teachers.
					<br />
					<span className="sm_hand_line">Loved by Students.</span>
				</p>
			</div>

			<div className="sm_hero_copy" {...revealProps("left")}>
				<h1 className="sm_display">
					Transform Study Time
					<br />
					<span className="sm_accent">into Game Time</span>
				</h1>
				<p className="sm_lead">Create teacher-controlled gaming study guides that reinforce what you’re already teaching, engage students, and give you insight into their performance.</p>
				<div className="sm_btn_row">
					<SiteButton to={CTA.pilot.to}>{CTA.pilot.label}</SiteButton>
				</div>
				<ul className="hh_highlights" aria-label="What Subjects Master gives you">
					{PILLARS.map((pillar) => (
						<li key={pillar.key}>
							<ToneIcon iconKey={pillar.key} tone={pillar.tone} />
							<span className="sm_label">{pillar.title}</span>
						</li>
					))}
				</ul>
			</div>
		</div>
	</HomeHero>
);

export default HeroBanner;
